import React from 'react';

function Footer() {
  return (
    <footer className="w-full border-t border-border mt-12">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="text-center text-sm text-muted-foreground">
          <p>&copy; 2025 SuperClaude-Org. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
